import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";

export const GrowthSettingsService = {
  async get(userId) {
    const snap = await getDoc(doc(db, "growthSettings", userId));
    return snap.exists() ? snap.data() : {};
  },

  async save(userId, settings) {
    await setDoc(doc(db, "growthSettings", userId), settings, { merge: true });
  },
};
